module.exports = __webpack_public_path__ + "assets/text52.png";